import { Box, Typography } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import dayjs from 'dayjs';
import { VehicleDeadline, formatDeadline, weekDayName } from '../submission-send-rules';

// Situação do prazo do veículo para a data escolhida (informativa: a API decide)
export function VehicleDeadlineLine({ deadline, publishDate }: { deadline: VehicleDeadline; publishDate: string | null }) {
    let icon = <ScheduleIcon fontSize="inherit" />;
    let color = 'text.secondary';
    let text = 'Informe a data de publicação para ver o prazo';

    if (publishDate && !deadline.publishesOnDay) {
        icon = <EventBusyIcon fontSize="inherit" />;
        color = 'error.main';
        text = `Não publica em ${weekDayName(dayjs(publishDate))} · ${deadline.allowedDays}`;
    } else if (deadline.deadline && deadline.expired) {
        icon = <WarningAmberIcon fontSize="inherit" />;
        color = 'warning.dark';
        text = `Prazo encerrado (${formatDeadline(deadline.deadline)})`;
    } else if (deadline.deadline) {
        color = 'success.dark';
        text = `Enviar até ${formatDeadline(deadline.deadline)}`;
    } else if (publishDate) {
        text = 'Sem prazo-limite cadastrado';
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color, fontSize: 16 }}>
            {icon}
            <Typography variant="caption" fontWeight={600} color="inherit">{text}</Typography>
        </Box>
    );
}
